// src/config/general.js
// Configuraciones generales de la aplicación
import noImageAvailable from '../assets/no-image-available.jpg'

export const LOCALSTORAGE_KEY = 'tiendoline-admin'
export const API_URL = process.env.REACT_APP_API_URL
export const API_UPLOADS_URL = process.env.REACT_APP_API_URL + 'uploads/'
export const DEFAULT_FETCH_CUANTOS = 10
export const DEFAULT_IMAGE = noImageAvailable
export const GOOGLE_MAPS_API_KEY = 'AIzaSyAOdEMmsrEq0rkZKO-yIAoIXwg7YaDNhn4'

// Secciones de contenido habilitadas en el menú admin
export const FAQ_HABILITADA = false           // Chispa no usa FAQ
export const TYC_HABILITADA = false           // Chispa no usa Terminos y Condiciones
export const PUBLICACIONES_HABILITADAS = false // Chispa no usa Publicaciones